import * as axiosHelper from './api_helper'

export const getAssets = async () => {
  const result = await axiosHelper.get('/asset/all')
  if (result.status) return result.result
  else throw new Error(result.message)
}

// New API function to fetch all assets from the root endpoint
export const getAllAssets = async () => {
  const result = await axiosHelper.get('/asset/')
  if (result.status) return result.result
  else throw new Error(result.message)
}

export const getReferenceCurrency = async () => {
  const result = await axiosHelper.get('/htx/reference/currency')
  if (result.status) return result.result
  throw new Error(result.message)
}
export const getDepositAddress = async (currency, chain) => {
  const result = await axiosHelper.post('/register/addressDeposit', {currency, chain})
  if (result.status) return result.result
  throw new Error(result.message)
}